const c = {
  name: "ConfigurationEqualizer",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 39.8" style="enable-background:new 0 0 40 39.8;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,8.8c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4s4-1.8,4-4C24,10.5,22.2,8.8,20,8.8z M18,12.8c0-1.1,0.9-2,2-2
			c1.1,0,2,0.9,2,2s-0.9,2-2,2C18.9,14.8,18,13.9,18,12.8z"/>
		<path class="st0" d="M17.3,0l0.3,1c0.3,1,1.3,1.8,2.4,1.8S22.1,2,22.4,1l0.3-1l1,0.3c2,0.6,3.9,1.7,5.4,3.1l0.7,0.7L29,4.8
			c-0.7,0.8-0.9,2-0.4,3c0.6,1,1.7,1.4,2.8,1.2l1-0.2l0.2,1c0.2,1,0.4,2,0.4,3.1s-0.1,2.1-0.4,3.1l-0.2,1l-1-0.2
			c-1.1-0.3-2.2,0.2-2.8,1.2c-0.6,1-0.4,2.2,0.4,3l0.7,0.7L29,22.1c-1.5,1.4-3.3,2.5-5.4,3.1l-1,0.3l-0.3-1c-0.3-1-1.3-1.8-2.4-1.8
			s-2.1,0.8-2.4,1.8l-0.3,1l-1-0.3c-2-0.6-3.9-1.7-5.4-3.1l-0.7-0.7l0.7-0.7c0.7-0.8,0.9-2,0.4-3c-0.6-1-1.7-1.4-2.8-1.2l-1,0.2
			l-0.2-1c-0.2-1-0.4-2-0.4-3.1s0.1-2.1,0.4-3.1l0.2-1l1,0.2c1.1,0.3,2.2-0.2,2.8-1.2c0.6-1,0.4-2.2-0.4-3l-0.7-0.7L11,3.4
			c1.5-1.4,3.3-2.5,5.4-3.1L17.3,0z M13.1,4.2c0.8,1.3,0.9,3.1,0,4.5l0,0c-0.8,1.5-2.4,2.3-3.9,2.2C9,11.6,9,12.2,9,12.8
			c0,0.6,0,1.2,0.1,1.8c1.6,0,3.1,0.8,3.9,2.2l0,0c0.8,1.5,0.8,3.2,0,4.5c0.9,0.7,1.9,1.3,3,1.8c0.8-1.4,2.2-2.3,3.9-2.3
			c1.7,0,3.1,0.9,3.9,2.3c1.1-0.4,2.1-1,3-1.8c-0.8-1.3-0.9-3.1,0-4.5l0,0c0.8-1.5,2.4-2.3,3.9-2.2c0.1-0.6,0.1-1.2,0.1-1.8
			c0-0.6,0-1.2-0.1-1.8c-1.6,0-3.1-0.8-3.9-2.2l0,0c-0.8-1.5-0.8-3.2,0-4.5c-0.9-0.7-1.9-1.3-3-1.8c-0.8,1.4-2.2,2.3-3.9,2.3
			c-1.7,0-3.1-0.9-3.9-2.3C15,2.9,14,3.5,13.1,4.2z"/>
		<path class="st0" d="M0,27.8h3.1c0.4-1.7,2-3,3.9-3s3.4,1.3,3.9,3H40v2H10.9c-0.4,1.7-2,3-3.9,3s-3.4-1.3-3.9-3H0V27.8z M7,26.8
			c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2s2-0.9,2-2C9,27.7,8.1,26.8,7,26.8z"/>
		<path class="st0" d="M23.9,34.8H40v2H23.9c-0.4,1.7-2,3-3.9,3s-3.4-1.3-3.9-3H0v-2h16.1c0.4-1.7,2-3,3.9-3S23.4,33,23.9,34.8z
			 M18,35.8c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2s-0.9-2-2-2C18.9,33.8,18,34.7,18,35.8z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as ConfigurationEqualizer
};
